module.exports = __webpack_public_path__ + "static/media/finishReminder.60044c2d.png";